import { atom } from 'jotai';

/**
 * True when the session context UI is mounted with a linked patient and at least
 * one prior Heidi session available for context (see PastSessionsButton).
 * Drives INTENDS_TO_AUTO_LINK_SESSIONS launch-modal eligibility only.
 */
export const autoPullHistorySpotlightEligibleAtom = atom(false);
